import styled from "@emotion/styled";
import React, { useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import Popover from "@mui/material/Popover";
import TabList from "@mui/lab/TabList";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormLabel from "@mui/material/FormLabel";
import {
  Avatar,
  Box,
  ButtonGroup,
  Checkbox,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  Tab,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import CartItem from "./CartItem";
import { useSelector, useDispatch } from "react-redux";

import {
  addItem,
  addProduct,
  clearCart,
  removeItem,
  setDonationType,
  setSelectProductError,
} from "./slice";
import { debounce, result } from "lodash";
import { ComponentType, units } from "../../common/enum";
import SvgIconStyle from "../../components/SvgIconStyle";
import ConfirmDialog from "../../components/ConfirmDialog";
import { setConfirmationDialog } from "../AdminView/adminSlice";
import Rating from "@mui/material/Rating";
import { useData } from '../OnBoarding/DataContext';



const RatingEventos = ({ t }) => {
  const { setSharedData } = useData();
  const { sharedData } = useData();
  const {donationIDEventos , collectionEventos ,motiveEventos,ratingEventos} = sharedData;
  const [ratingValue, setRatingValue] = React.useState(0);
  const [ratingError, setRatingError] = React.useState(false);
  const [motive, setMotive] = React.useState("");
  const [motiveError, setMotiveError] = React.useState(false);
  const rate = React.useRef();
  rate.current = ratingValue;
  const [numPessoas, setNumPessoas] = useState('');
  
  const handleNumPessoasChange = (event) => {
    const sanitizedInput = event.target.value.replace(/\D/g, '');

    if (/^\d*$/.test(sanitizedInput)) {
      setNumPessoas(sanitizedInput);
       var numberBenef = sanitizedInput;
       var donationIDEventos = sharedData.donationIDEventos;
       var collectionEventos = sharedData.collectionEventos
       var motiveEventos = motive
       var ratingEventos = rate.current

      setSharedData({
        numberBenef,
        donationIDEventos,
        collectionEventos,
        motiveEventos,
        ratingEventos
      });
    }
  };

  // var donationID = collection.collection.donationId;
  // var ratingEventos = ratingValue
  //   setSharedData({
  //     ratingEventos
  //   });

  return (
    <>
    <Stack padding={"3%"} spacing={3}>
        <Typography fontSize={"subheading"} fontWeight={"bold"}>
          {"Avaliar a doação tipo evento"}
        </Typography>
        <Paper>
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <Rating
              component="span"
              name="simple-controlled"
              defaultValue={ratingValue}
              value={ratingValue}
              onChange={(event, newValue) => {
                setRatingValue(newValue);
                setRatingError(false);
              }}
              //precision={0.1}
              />
              {ratingError && (
              <Typography variant="subtitle2" color="error">
                O campo é de preenchimento obrigatório
              </Typography>
              )}
              <TextField
              id="motivoEventos"
              sx={{ width: "100%", mt: 1 }}
              label={'Escreva a sua opinião...'}
              multiline
              minRows={4}
              value={motive}
              onChange={(e) => {
                setMotive(e.target.value);
                setMotiveError(false);
              }}
              required={false}
              error={motiveError}
              helperText={
                motiveError &&
                `O campo ${t("remarks")} é de preenchimento obrigatório`
              }
            />
          {ratingError && (
          <Typography variant="subtitle2" color="error">
            O campo é de preenchimento obrigatório
          </Typography>
          )}
          <TextField
            sx={{ width: '50%', mt: 3 }}
            label={'Nº pessoas que irão beneficiar'}
            type="text"
            id="numPessoas"
            value={numPessoas}
            onChange={handleNumPessoasChange}
          />
          </Box>
        </Paper>
    </Stack>
    </>
  );
};

export default RatingEventos;
